// extracted by css-extract-rspack-plugin
export default {"ReposCountText":"ReposList-module__ReposCountText__Dnvq2","ReposListContainer":"ReposList-module__ReposListContainer__BrFiJ"};